import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/* eslint-disable import/prefer-default-export */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseForm(form: HTMLFormElement) {
  const formData = new FormData(form);
  const obj: Record<string, string> = {};
  formData.forEach((value, key) => {
    obj[key] = value.toString();
  });
  return obj;
}
